import React, { useEffect, useState } from 'react'
import Layout from '../component/Layout/Layout'
import { useNavigate, useSearchParams } from 'react-router-dom'
import axios from 'axios';
import { useCart } from '../context/cart';

const StripePaymentSuccess = () => {
        const [cart,setCart] = useCart();
        const [loading, setLoading] = useState(false);
        const [searchParams, setSearchParams] = useSearchParams();
        const navigate = useNavigate();
        const prmData = Object.fromEntries([...searchParams]);

        const updatePayment = async()=>{
            setLoading(true);
            try {
                const {data} = await axios.post(`${process.env.REACT_APP_API_URL}/payment/pay-stripe-success`,prmData);
                if (data?.status) {
                    localStorage.removeItem("cart");
                    setCart([]);
                    setLoading(false);
                    const o_id = data?.order_ids[0];
                    navigate(`/myorders?order=1&o_id=${o_id}`);
                    return;
                }
            } catch (error) {
                console.log(error)
            }
        }
        useEffect(()=>{
          updatePayment();
        },[])

  return (
  
    <div className={`site-content-wrap my-account`}>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="loading-div">
                <h2>Please wait payment is under processing...</h2>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}

export default StripePaymentSuccess
